export default {
    getHeaderFields: state => state.headerFields,
    getDataTableOptions: state => state.dataTableOptions,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getSearchFields: state => state.searchFields,
    getRowActions: state => state.rowActions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getBedHeaderFields: state => state.bedHeaderFields,
    getBedFormActions: state => state.bedFormActions,
    getBedActions: state => state.bedActions,
    getBedRowActions: state => state.bedRowActions,
    isBedFormOpen: state => state.bedFormIsOpen,
    isBedGridOpen: state => state.bedGridIsOpen,

}
